import * as React from 'react';
import AccessibleSVG from 'box-ui-elements/es/icons/accessible-svg';
import { bdlGray } from 'box-ui-elements/es/styles/variables';

type Props = {
  className?: string;
  color?: string;
  height?: number;
  title?: string;
  width?: number;
};

const FontColorIcon = ({
  className = '',
  color = bdlGray,
  height = 16,
  title,
  width = 16,
}: Props) => (
  <AccessibleSVG
    className={className}
    height={height}
    title={title}
    viewBox="0 0 16 16"
    width={width}
  >
    <path
      clipRule="evenodd"
      d="M9.3611 1.96833C9.16693 1.62049 8.7977 1.39999 8.39223 1.39999H7.60777L7.47415 1.40803C7.07845 1.45588 6.7344 1.71387 6.58085 2.08887L2.08377 13.0713L2.04163 13.1934C1.84551 13.8871 2.36579 14.6 3.11069 14.6H3.71652L3.8747 14.5915C4.13611 14.5631 4.38482 14.4638 4.59607 14.2949L4.71448 14.1896L4.82042 14.0729C4.91984 13.9507 4.9992 13.8123 5.05443 13.6606L6.04883 11.2005H9.95006L10.9595 13.6969L11.0234 13.8329C11.1156 14.0083 11.2364 14.1596 11.3867 14.2848C11.6433 14.4984 11.955 14.6 12.2757 14.6H12.8893L13.0183 14.5927C13.7351 14.5114 14.1983 13.7602 13.9162 13.0713L9.41915 2.08887L9.3611 1.96833ZM6.66875 9.09992L8.00093 5.79992L9.33129 9.09992H6.66875Z"
      fill={color}
      fillRule="evenodd"
    />
  </AccessibleSVG>
);

export default FontColorIcon;
